import React from "react";
import { useTranslation } from "react-i18next";

export default function About() {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-main bg-no-repeat bg-cover text-white flex flex-col items-center justify-start px-4 md:px-16 lg:px-24">
            <div className="text-center mt-48">
                <h1 className="jersey25 text-6xl md:text-9xl leading-none text-white font-bold">
                    ABOUT KOSTRAD RUN
                </h1>
                <div className="jersey25 text-xl md:text-3xl text-black mt-6 max-w-4xl mx-auto p-8 rounded-3xl bg-brandGrey/50">
                    <p>KOSTRAD RUN digelar dalam rangka HUT Kostrad ke-65 tahun 2026 sebagai ajang lari yang mempertemukan masyarakat, prajurit TNI, dan keluarga besar TNI dengan mengusung semangat juang, disiplin militer, serta kemanunggalan TNI-Rakyat.</p><br />
                    <p>Event ini tidak hanya menghadirkan pengalaman olahraga yang menyenangkan, tetapi juga menjadi ruang kebersamaan untuk mempererat kedekatan antara Kostrad dan masyarakat sekaligus mendorong tumbuhnya gaya hidup sehat.</p><br />
                    <p>Wujudkan "Run With Honor" di setiap langkah, nikmati setiap proses, berikan yang terbaik, dan capai garis finish dengan penuh kebanggaan dan kehormatan.</p>
                </div>
            </div>
        </div>
    );
}
